const getters = {
    getServiceCategory(state) {
        return state.serviceCategory;
    },
    getServiceCategoryList(state) {
        return state.serviceCategoryList;
    }
}
export default getters;